import axios from 'axios'
import { processAthlete } from '@/store/modules/athletes/detail'

// state
export const state = {
  athletesPerformance: [],
  isAthletesPerformanceLoading: true,
}

// getters
export const getters = {
  athletes: ({ athletesPerformance }) => athletesPerformance.map(({ athlete }) => athlete),
}
// mutations
export const mutations = {
  fetchAthletesPerformanceStart(state) {
    state.isAthletesPerformanceLoading = true
  },
  fetchAthletesPerformanceSuccess(state, { athletesPerformance }) {
    state.athletesPerformance = athletesPerformance.map((performance) => {
      return {
        ...performance,
        athlete: processAthlete(performance.athlete),
      }
    })
    state.isAthletesPerformanceLoading = false
  },
  fetchAthletesPerformanceFailed(state) {
    state.isAthletesPerformanceLoading = false
  },
}
// actions
export const actions = {
  async fetchAthletesPerformance({ commit }, { roundId } = {}) {
    let athletesPerformance = null
    try {
      commit('fetchAthletesPerformanceStart')
      athletesPerformance = await axios.get(`round/${roundId}/performance`)
      commit('fetchAthletesPerformanceSuccess', { roundId, athletesPerformance })
    } catch (e) {
      commit('fetchAthletesPerformanceFailed')
    }
    return athletesPerformance
  },
}
